import { useState, useRef, useCallback } from 'react';

/**
 * Hook for managing multiple search/popup states
 * Handles open states, refs, and position calculation for popups
 */
export function usePopupManager() {
  // Popup open states
  const [unifiedSearchOpen, setUnifiedSearchOpen] = useState(false);
  const [trashPopupOpen, setTrashPopupOpen] = useState(false);
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
  
  // Refs for positioning popups
  const unifiedSearchBtnRef = useRef(null);
  const trashBtnRef = useRef(null);

  // Open popup with position calculation
  const openPopup = useCallback((buttonRef, setPopupOpen) => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setPopupPosition({
        top: rect.top,
        left: rect.right + 8,
      });
    }
    setPopupOpen(true);
  }, []);

  // Convenience methods for each popup
  const openUnifiedSearch = useCallback(() => {
    openPopup(unifiedSearchBtnRef, setUnifiedSearchOpen);
  }, [openPopup]);

  const openTrashPopup = useCallback(() => {
    openPopup(trashBtnRef, setTrashPopupOpen);
  }, [openPopup]);

  const closeUnifiedSearch = useCallback(() => setUnifiedSearchOpen(false), []);
  const closeTrashPopup = useCallback(() => setTrashPopupOpen(false), []);

  return {
    // States
    unifiedSearchOpen,
    trashPopupOpen,
    popupPosition,
    // Refs
    unifiedSearchBtnRef,
    trashBtnRef,
    // Open handlers
    openUnifiedSearch,
    openTrashPopup,
    // Close handlers
    closeUnifiedSearch,
    closeTrashPopup,
  };
}

export default usePopupManager;
